module.exports = "<chat-message *ngFor=\"let message of messages\" [message]=\"message\" [user]=\"user\"></chat-message>";


//////////////////
// WEBPACK FOOTER
// ./src/app/chat/messages-container/messages-container.component.pug
// module id = 1039
// module chunks = 0